import { z } from 'zod';
/**
 * Единый формат фильтра (docs/PLAN.md, раздел 6.1): его строит FilterBuilder,
 * понимают API (SQL), сохранённые фильтры, экспорт и будущий desktop (domain.matchesFilter).
 */
export const FilterOperator = z.enum([
    'eq',
    'neq',
    'in',
    'contains',
    'gte',
    'lte',
    'between',
    'is_set',
    'is_not_set',
]);
export const FilterCondition = z.object({
    field: z.string().min(1),
    op: FilterOperator,
    value: z.unknown().optional(),
});
export const FilterSpec = z.object({
    /** Все условия должны выполняться. */
    and: z.array(FilterCondition).max(50),
});
export const emptyFilter = () => ({ and: [] });
//# sourceMappingURL=filter.js.map